"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  slidesNumb: 4,
  slidesList: [4, 1, 2, 3, 4, 1],
  animDuration: 500,
  animFunction: 'linear',
  animTimeoutId: null,
  autoPlay: false,
  autoPlayBehavior: 'infinite',
  autoPlayInterval: 1000,
  autoPlayDelay: 5000,
  autoPlayPause: 1000,
  autoPlayIntervalId: null,
  autoPlayDelayId: null,
  autoPlayPauseId: null,
  active: 1,
  position: 100,
  animate: false,
  lock: false
};
exports["default"] = _default;